import { render, staticRenderFns } from "./servicoGrafico.vue?vue&type=template&id=34f996a4&scoped=true&"
import script from "./servicoGrafico.vue?vue&type=script&lang=js&"
export * from "./servicoGrafico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f996a4",
  null
  
)

export default component.exports